const datetime = new Date().toISOString();
//const quasiRandomNumber = Math.random().toString().split("0.")[1];
const quasiRandomNumber = (window.crypto.getRandomValues(new Uint32Array(1))[0]).toString().split("0.")[1];//codeql vul fix stuti

const sessionId = `${datetime}-${quasiRandomNumber}`;

exports.sessionId = sessionId;
